import React, { useRef, useState } from "react";
import { Button, CreateAlert, IInputProps } from "../../../modules";
import "./index.scss";
import { UploadService } from "../../../services/upload/upload.service";

export type InputImportProps = IInputProps

const InputImport: React.FC<InputImportProps> = ({ onChange, value, placeholder }) => {
  const inputImportRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fileName, setFileName] = useState(value || '');

  const handleImportFile = async (files: FileList | null) => {
    if (!files) return

    try {
      setIsLoading(true)

      const formData = new FormData();
      formData.append("file", files[0]);
  
      const url = await UploadService.singleUpload(formData)
  
      setFileName(url)
      onChange({
        formData,
        file: files[0],
        url
      })
    } catch (error) {
      CreateAlert({
        type: "danger",
        message: "Upload file thất bại",
      });
    } finally {
      setIsLoading(false)
    }
  };

  const onClickButton = () => {
    if (isLoading) return
    inputImportRef?.current?.click();
  };

  return (
    <div className="input-import-wrapper">
      <Button label="Nhập file" buttonType="info" onClick={onClickButton} isLoading={isLoading}/>
      <input
        ref={inputImportRef}
        type="file"
        hidden
        readOnly
        onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
          await handleImportFile(e?.target?.files);
          // inputImportRef.current.value = "";
        }}
      />
      <input
        type="text"
        className="file-name-input"
        value={fileName}
        readOnly
        placeholder={placeholder}
      />  
    </div>
  );
};

export default InputImport;
